<template>
  <div class="saved-search-meta-chips d-flex flex-wrap gap-2 mb-1" @click.stop.prevent>
    <v-chip
      v-for="search in sortedMatchedSearches"
      :key="search.search_id"
      x-small
      class="contract-chip contract-chip-group"
      style="cursor: pointer;"
      @click.stop.prevent="openSavedProfileTab(search.search_id)"
    >
      <v-icon x-small left class="contract-chip-icon">
        mdi-magnify
      </v-icon>
      {{ search.search_name }}
    </v-chip>

    <v-chip
      v-if="categoryLabel"
      x-small
      class="contract-chip saved-search-category-chip"
    >
      <v-icon x-small left class="contract-chip-icon saved-search-category-chip-icon">
        mdi-tag-outline
      </v-icon>
      <span class="saved-search-category-chip-label">{{ categoryLabel }}</span>
    </v-chip>

    <v-chip
      v-if="dispositionLabel"
      x-small
      text-color="white"
      class="contract-chip saved-search-disposition-chip"
      :style="{ backgroundColor: dispositionColor }"
      style="cursor: pointer;"
      @click.stop.prevent="handleDispositionChipClick"
    >
      {{ dispositionLabel }}
    </v-chip>
  </div>
</template>

<script>
import { dispositionDisplayGroup, dispositionKind } from '../../utils/savedSearchDisplayGroups.js';

export default {
  name: 'SavedSearchMetaChips',

  props: {
    /** Saved-search digest row (normalized match object). */
    row: {
      type: Object,
      required: true,
    },
  },

  computed: {
    sortedMatchedSearches() {
      const matches = Array.isArray(this.row?.matched_searches)
        ? [...this.row.matched_searches]
        : [];
      return matches.sort((a, b) => {
        const idA = a?.search_id ?? 0;
        const idB = b?.search_id ?? 0;
        if (idA !== idB) return idA - idB;
        return String(a?.search_name || '').localeCompare(String(b?.search_name || ''));
      });
    },

    categoryLabel() {
      return (this.row?.category || '').trim();
    },

    dispositionLabel() {
      return (this.row?.disposition || '').trim();
    },

    dispositionColor() {
      // Match Tender.vue / ResultsTableVuetify dispositionColor
      switch (dispositionKind(this.dispositionLabel)) {
        case 'request_tender':
        case 'grant_opportunity':
          return '#4EB888';
        case 'contract_notice':
        case 'grant':
          return '#FF1463';
        default:
          return '#9e9e9e';
      }
    },
  },

  methods: {
    openSavedProfileTab(searchId) {
      if (searchId == null || searchId === '') return;

      const routeData = this.$router.resolve({
        name: 'search-profiles',
        query: { search_id: searchId },
      });
      window.open(routeData.href, '_blank');
    },

    handleDispositionChipClick() {
      const noticeType = dispositionDisplayGroup(this.row?.disposition);
      if (!noticeType) return;
      this.$emit('filter-notice-type', noticeType);
    },
  },
};
</script>

<style>
/* Colour variants only — sizing from global .contract-chip in BaseExpiringContracts */
.saved-search-meta-chips .contract-chip-group {
  background-color: #e6f0f5 !important;
  color: #12253a !important;
  font-weight: 500;
}

.saved-search-meta-chips .contract-chip-group .v-icon {
  color: #12253a !important;
}

.saved-search-meta-chips .saved-search-category-chip.v-chip {
  background-color: #112233 !important;
  color: #ffffff !important;
}

.saved-search-meta-chips .saved-search-category-chip .v-chip__content,
.saved-search-meta-chips .saved-search-category-chip .v-icon {
  color: #ffffff !important;
}

.saved-search-meta-chips .saved-search-category-chip .v-chip__content {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 320px;
}

.saved-search-meta-chips .saved-search-category-chip-icon {
  flex-shrink: 0;
}

.saved-search-meta-chips .saved-search-category-chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.saved-search-meta-chips .saved-search-disposition-chip.v-chip {
  font-weight: 500;
}

.saved-search-meta-chips .saved-search-disposition-chip .v-chip__content {
  color: #ffffff !important;
}
</style>
